import { Routes } from '@angular/router';

export const FullLayout_ROUTES: Routes = [
    {
        path: 'login',
        loadComponent: () => import('../../authentication/authentication.module').then(m => m.AuthenticationModule)
    }
];

//AuthenticationModule